import { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { useUserInfoContext } from "../../lib/contexts/UserInfoContext";
import { isAnyAdmin, isUserAuthorized } from "@common/domain/auth";

export const AdminAuth = () => {
  const navigate = useNavigate();
  const { userInfo } = useUserInfoContext();

  useEffect(() => {
    if (userInfo) {
      if (!isUserAuthorized(userInfo.groups)) {
        navigate("/unauthorized");
      } else if (!isAnyAdmin(userInfo.groups)) {
        navigate("/");
      }
    }
  }, [userInfo, navigate]);

  if (!userInfo || !isAnyAdmin(userInfo.groups)) {
    return null;
  }

  return <Outlet />;
};
